import React, { useState } from "react";
import TopNavbar from "../top-navbar/TopNav";
import Sidebar from "./Sidebar";
import { verifyQuickUAN, saveQuickUAN } from "../../services/employee/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
const QuickUANCheck = () => {
  const [uan, setUan] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [uanData, setUanData] = useState(null);
  const [error , setError ] = useState("")

  const candidateId = localStorage.getItem("QuickBGC_candidateID");
  const id = localStorage.getItem("QuickBGC_candidateID");

  const navigate = useNavigate();

  const handleBack = () => {
    if (id) {
      navigate(`/employee/quickbgv-dashboard/${id}`);
    } else {
      navigate(-1); // Fallback to previous page in history
    }
  };

  const handleVerify = async () => {
    try {
      if (!uan.trim()) {
        setError("Please enter UAN Number");
        return;
      }

      if (!/^\d{12}$/.test(uan)) {
        setError("UAN must be exactly 12 digits");
        return;
      }

      setLoading(true);

      const response = await verifyQuickUAN({
        id_number: uan,
      });

      if (response?.data?.uan) {
        setUanData(response.data);
      } else {
        setError("Invalid UAN");
      }
    } catch (error) {
     setError("Invalid UAN , Please Enter a Valid UAN");
    } finally {
      setLoading(false);
    }
  };

  // 1. In handleSave:
  const handleSave = async () => {
    try {
      if (!candidateId) {
        toast.error(
          "Candidate ID not found. Please reselect candidate from dashboard.",
        );
        return;
      }

      setSaving(true);

      const payload = {
        candidateId,
        uan,
        employmentHistory: uanData?.employmentHistory || [],
      };

      const response = await saveQuickUAN(payload);
      //  alert("Successfully")
      toast.success("UAN Details Saved Successfully");
      handleBack();
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Invalid UAN , Please Enter a Valid UAN",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="dashboard-app-container">
      <ToastContainer position="top-right" autoClose={3000} />
      <Sidebar />

      <div className="dashboard-right-panel">
        <TopNavbar />

        <div className="container-fluid py-4">
          <div className="row justify-content-center">
            <div className="col-xl-11">
              <div className="quickbgv-uan-main-card">
                {/* Header Section with Integrated Back Button */}
              <div className="quickbgv-uan-header  bg-white rounded-top">
  <div className="d-flex align-items-center gap-3 ">
    {/* Modernized Back Button */}
    <button
  type="button"
  className="quick-btn-back-custom  p-0 d-flex align-items-center justify-content-center"
  onClick={handleBack}
  title="Go Back"
>
  <FaArrowLeft size={16} />
</button>

    {/* Title & Subtitle */}
    <div className="flex-grow-1">
      <h3 className="fw-bold mb-1" style={{ color: "#4a154b", fontSize: "1.25rem" }}>
        UAN Verification
      </h3>
      <p className="text-muted mb-0" style={{ fontSize: "0.875rem" }}>
        Verify candidate employment history using EPFO records.
      </p>
    </div>
  </div>
</div>

                {!uanData ? (
                  <div className="quickbgv-uan-verification-screen">
                    <div className="quickbgv-uan-icon-wrapper">
                      <div className="quickbgv-uan-icon">🏢</div>
                    </div>

                    <h3 className="quickbgv-verify-title">
                      Verify Employee UAN
                    </h3>

                    <p className="quickbgv-verify-subtitle">
                      Enter the candidate's 12 digit UAN number to fetch
                      employment records.
                    </p>

                    <div className="row justify-content-center">
                      <div className="col-lg-4 col-md-6">
                        <input
                          type="text"
                          className="form-control quickbgv-uan-input"
                          placeholder="Enter 12 Digit UAN"
                          value={uan}
                          maxLength={12}
                          onChange={(e) =>
                            setUan(e.target.value.replace(/\D/g, ""))
                          }
                        />
                                {error && <div className="quickuan-error-message">* {error}</div>}

                        <button
                          className="quickbgv-verify-btn"
                          onClick={handleVerify}
                          disabled={loading}
                        >
                          {loading ? "Verifying..." : "Verify UAN"}
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="quickbgv-uan-top-section">
                      <div>
                        <h4 className="mb-1">Employment History</h4>
                        <p className="text-muted mb-0">
                          UAN verified successfully.
                        </p>
                      </div>

                      <div className="quickbgv-status-badge">✓ Verified</div>
                    </div>

                    <div className="row g-3 mb-4">
                      <div className="col-lg-6">
                        <div className="quickbgv-summary-card">
                          <span>UAN Number</span>
                          <h5>{uanData.uan}</h5>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="quickbgv-summary-card">
                          <span>Total Companies</span>
                          <h5>{uanData?.employmentHistory?.length}</h5>
                        </div>
                      </div>
                    </div>

                    <div className="quickbgv-table-wrapper">
                      <div className="table-responsive">
                        <table className="table align-middle mb-0">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Guardian Name</th>
                              <th>Company</th>
                              <th>Member ID</th>
                              <th>DOJ</th>
                              <th>DOE</th>
                            </tr>
                          </thead>
                          <tbody>
                            {uanData?.employmentHistory?.length > 0 ? (
                              uanData.employmentHistory.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.name || "-"}</td>
                                  <td>{item.guardianName || "-"}</td>
                                  <td>{item.companyName || "-"}</td>
                                  <td>{item.memberId || "-"}</td>
                                  <td>{item.dojEpf || "-"}</td>
                                  <td>
                                    {item.doeEpf === "null" || !item.doeEpf ? (
                                      <span className="quickbgv-active-badge">
                                        Active
                                      </span>
                                    ) : (
                                      item.doeEpf
                                    )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="6"
                                  className="text-center text-muted py-3"
                                >
                                  <b>
                                    UAN verified successfully, but no
                                    active/past employment history found.
                                  </b>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="quickbgv-action-buttons">

                      <button
                        className="save-cancel-btn"
                        onClick={() => navigate(`/employee/quickbgv-dashboard/${id}`)}
                      >
                        Cancel
                      </button> 


                      <button
                        className="quickbgv-save-btn"
                        onClick={handleSave}
                        disabled={saving}
                      >
                        {saving ? "Saving..." : "Save Details"}
                      </button>

                         

                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickUANCheck;
